import * as React from "react"
import WarningCell from "./warning-cell"
import Tooltip from "../../../tooltip";
import { formatDeleveragingYears } from "../../../../domain/sfp/cash-flow-domain"

export default class DeleveragingYearsWarningCell
extends WarningCell {
	render() {
		const formattedValue = formatDeleveragingYears(this.props.value)

		return <div>
			{formattedValue}
			{this.state.mouseOver
			&& <Tooltip message={this.props.message}
			mouseMove={this.state.mouseMove} />}
		</div>
	}
}



// WEBPACK FOOTER //
// ./src/component/ppi/ppi-detail/utils/deleveraging-years-warning-cell.tsx